import React, { useState, useEffect } from "react";
import { Form, Button, Spinner } from "react-bootstrap";
import iq_api_v2 from "../../services/iqApiV2";
import { useUser } from "../../context/UserContext";
import Alert from "../HtmlElements/Alert";
import GenericTableSkeleton from "../Frontend/skeletons/tableSkeleton/genericTableSkeleton";
// import iq_api_v2 from "../api/iq_api_v2"; // adjust path to your API instance

export default function ContactSettings() {

  const {user} = useUser()
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiSuccess, setApiSuccess] = useState('');
  const [selectedSeniorities, setSelectedSeniorities] = useState([]);
  const [saving, setSaving] = useState(false);

  const person_seniorities = {
    owner: "Owner",
    founder: "Founder",
    c_suite: "C-Suite",
    partner: "Partner",
    vp: "VP",
    head: "Head",
    director: "Director",
    manager: "Manager",
    senior: "Senior",
    entry: "Entry",
    intern: "Intern",
  };

  // Fetch existing selected seniorities
  useEffect(() => {
    const fetchSeniorities = async () => {
      try {
        // console.log("user : " , user)
        setLoader(true);
        const response = await iq_api_v2.post(
          `/user_profile/get_contact_setting_profile`,
          { client: user?.company_name, user_id: user?.id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        const existing = response?.data?.seniorities ?? [];
        setSelectedSeniorities(existing);
      } catch (error) {
        console.error("Error fetching seniorities:", error);
      } finally {
        setLoader(false);
      }
    };
    fetchSeniorities();
  }, [user?.id]);

  // Handle checkbox toggle
  const handleCheckboxChange = (key) => {
    setSelectedSeniorities((prev) =>
      prev.includes(key)
        ? prev.filter((item) => item !== key)
        : [...prev, key]
    );
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    if (selectedSeniorities.length === 0) {
      setErrors({ seniorities: "Please select at least one option." });
      return;
    }

    try {
      setSaving(true);

      const formData = new URLSearchParams();
      formData.append("client", user?.company_name);
      formData.append("user_id", user?.id);
      selectedSeniorities.forEach((value) => formData.append("seniorities", value));

      const response = await iq_api_v2.post(
        `/user_profile/update_contact_setting_profile`,
        // {
        //   client:  user?.company_name, 
        //   user_id: user?.id,
        //   seniorities: selectedSeniorities,
        // },
        formData,
        {
          headers: {
            // Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      console.log("Saved successfully:", response.data);

      if(response?.data?.message == "success"){
        setApiSuccess("Contact Settings Saved Successfully !");
      }else{
        setErrors({ save: "Failed to update settings. Please try again." });
      }

      setTimeout(() => {
        setApiSuccess("");
        setErrors("")
      }, 5000);

    } catch (error) {
      console.error("Error saving seniorities:", error);
      setErrors({ save: "Failed to update settings. Please try again." });

      setTimeout(() => {
        setApiSuccess("");
        setErrors("")
      }, 5000);

    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="col-md-12 mt-4 request_demo_form_wrapper">

        <div className="col-md-12  user_profile_subblock container-fluid">
            <div className="offering_custom_card_block">

                {apiSuccess && (
                <Alert type="success" message={apiSuccess} />
                )}
                
                <div className="row mb-4">
                    <div className="col-md-3">
                        <h5 class="target_head mb-0">Contacts Seniorities</h5>
                    </div>
                </div>

                <div className="">
                {loader ? (
                    <div className="text-center my-3">
                    {/* <Spinner animation="border" size="sm" /> Loading... */}
                    <GenericTableSkeleton colCount={4} rowCount={3} />
                    </div>
                ) : (
                    <Form onSubmit={handleSubmit} className="w-100">

                    <Form.Group className="row mb-3">
                        <div className="col-md-12">
                            
                            <div className="row">
                                <div className="col-md-12">
                                    <span
                                        className="lable_target mb-2 d-block"
                                        style={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                        >
                                        Select Contact Seniorities
                                    </span>
                                </div>
                            </div>

                            <div className="row">
                            {Object.entries(person_seniorities).map(([key, label]) => (
                                // <Form.Check
                                // key={key}
                                // type="checkbox"
                                // label={label}
                                // id={key}
                                // className="col-md-3 form-check-input"
                                // checked={selectedSeniorities.includes(key)}
                                // onChange={() => handleCheckboxChange(key)}
                                // />

                                <div className="col-md-3">
                                    <Form.Check
                                    key={key}
                                    type="checkbox"
                                    className="form-check-inline radio_custom_btn"
                                    label={label}
                                    id={key}
                                    // name={`decisionMakers.${option}`}
                                    checked={selectedSeniorities.includes(key)}
                                    onChange={() => handleCheckboxChange(key)}
                                />
                                </div>
                            ))}
                            </div>

                            {errors.seniorities && (
                            <div className="text-danger mt-1">{errors.seniorities}</div>
                            )}
                        </div>
                    </Form.Group>

                    {errors.save && (
                        <div className="text-danger mb-2">{errors.save}</div>
                    )}
                    
                    <div className="align-right">
                        <div className="user_form_info float-right">
                            <Button type="submit" className="personalisation_button btn btn-primary btn-sm" disabled={saving}>
                                {saving ? (
                                <>
                                    <Spinner animation="border" size="sm" /> Saving...
                                </>
                                ) : (
                                "Save Settings"
                                )}
                            </Button>
                        </div>
                    </div>

                    </Form>
                )}
                </div>
                
            </div>
        </div>
    
    </div>
  );
}
